import responseMapper from "../responseMaps/responseMapper";
import { SXMResponse } from "../responseMaps/SXMResponse";

interface JsonObject {
    [index: string]: string;
}

export declare const HTTP_METHODS: readonly ['GET', 'HEAD', 'OPTIONS', 'POST', 'PUT', 'DELETE', 'PATCH'];
export type HTTP_METHOD = (typeof HTTP_METHODS)[number];

export default async function submit(action: string, method: HTTP_METHOD, formData: FormData) {
    const jsonData: JsonObject = {};
    const entriesIterator = formData.entries();
    let entry = entriesIterator.next();

    while (!entry.done) {
        jsonData[entry.value[0]] = entry.value[1] as string;
        entry = entriesIterator.next();
    }

    const response = await fetch(action, {
        method: method,
        body: JSON.stringify(jsonData),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response;
}

export  async function submitJson(action: string, method: HTTP_METHOD, formData: FormData) : Promise<SXMResponse> {
    const jsonData: JsonObject = {};
    const entriesIterator = formData.entries();
    let entry = entriesIterator.next();

    while (!entry.done) {
        jsonData[entry.value[0]] = entry.value[1] as string;
        entry = entriesIterator.next();
    }

    const response = await fetch(action, {
        method: method,
        body: JSON.stringify(jsonData),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return responseMapper(action, response);
}
